// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"580c2958","453":"a6a97343","867":"db2a8c14"}[chunkId] + ".chunk.js";
};